import { Box } from '@mui/material'
import React from 'react'
import { InfoLabel } from 'styles/utilities'
import ArrayLink from './ArrayLink'

interface LabelValueProps {
  label: string
  /** 'row' = label left / value right (default), 'stacked' = label top / value below */
  variant?: 'row' | 'stacked'
  /** Custom content — when provided, ArrayLink props are ignored */
  children?: React.ReactNode
  // ── ArrayLink pass-through props ──
  items?: any[] | null
  displayKey?: string
  route?: (item: any) => string
  value?: string | null
  to?: string
  external?: boolean
  displayText?: string
  copyable?: boolean
  isCopied?: boolean
  onCopy?: () => void
  emptyText?: string
}

const LabelValue = ({ label, variant = 'row', children, ...arrayLinkProps }: LabelValueProps) => {
  const content = children || <ArrayLink {...arrayLinkProps} />

  if (variant === 'stacked') {
    return (
      <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1, px: 1.5, py: 0.75 }}>
        <InfoLabel>{label}</InfoLabel>
        {content}
      </Box>
    )
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        alignItems: 'center',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        px: 1.5,
        py: 0.75,
      }}
    >
      <InfoLabel sx={{ mb: 0 }}>{label}</InfoLabel>
      <Box sx={{ overflow: 'hidden', minWidth: 0, display: 'flex', justifyContent: 'flex-end' }}>
        {content}
      </Box>
    </Box>
  )
}

export default LabelValue
